import { create as createJss, Plugin } from "jss";
import preset from "jss-preset-default";
import { mediaQueryScaleStyles } from "../models/screen";

const rewriteHoverKeys = (
  style: Record<string, unknown>,
): Record<string, unknown> => {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(style)) {
    const newKey =
      key.includes(":hover") && !key.includes("data-input-mode")
        ? key.replace(
            /&:hover/g,
            'body:not([data-input-mode="gamepad"]) &:hover',
          )
        : key;

    result[newKey] =
      value && typeof value === "object" && !Array.isArray(value)
        ? rewriteHoverKeys(value as Record<string, unknown>)
        : value;
  }
  return result;
};

const hoverRewritePlugin = () => ({
  onProcessStyle: (style: unknown) =>
    rewriteHoverKeys(style as Record<string, unknown>),
});

const mediaQueryPlugin = () => ({
  onProcessStyle: (style: unknown) =>
    mediaQueryScaleStyles(style as Record<string, number | string>),
});

const pr = preset();
const plugins = [hoverRewritePlugin(), ...pr.plugins, mediaQueryPlugin()];
const jss = createJss({
  plugins: plugins as Plugin[],
});

export default jss;
